import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { clearStoredAuth, ensureValidSession } from '../utils/auth';

export default function PrivateRoute({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    let cancelled = false;

    ensureValidSession().then((result) => {
      if (cancelled) {
        return;
      }

      if (!result?.ok) {
        clearStoredAuth();
        setStatus('unauthenticated');
        return;
      }

      setStatus('authorized');
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'checking') {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '2rem' }}>
        <p>Validando sesión...</p>
      </div>
    );
  }

  if (status !== 'authorized') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
